import React from "react";
import { renderDate } from "../../../../../../utils/helpers";
import AiFillCalendar from "@meronex/icons/ai/AiFillCalendar";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DealValidity(_ref) {
  var date = _ref.date,
    removeTopMargin = _ref.removeTopMargin;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex ".concat(removeTopMargin ? " mt-4" : "mt-5 lg:mt-6  ", " items-center"),
    children: [/*#__PURE__*/_jsx(AiFillCalendar, {}), /*#__PURE__*/_jsxs("p", {
      className: "ml-2 font-medium capitalize text-sm  tracking-wide ",
      children: ["Valid till:", " ", /*#__PURE__*/_jsx("span", {
        className: "text-primary font-medium",
        children: renderDate(date, false)
      })]
    })]
  });
}
export default DealValidity;